import { useState, useEffect } from 'react';
import { generateDefaultSnapshotName } from '../../utils/snapshot';

export function useSnapshotName(migrationName: string, initial?: string) {
  const [snapshotName, setSnapshotName] = useState<string>(
    initial ?? generateDefaultSnapshotName(migrationName)
  );
  const [snapshotNameEdited, setSnapshotNameEdited] = useState<boolean>(Boolean(initial));

  useEffect(() => {
    if (!snapshotNameEdited) {
      setSnapshotName(generateDefaultSnapshotName(migrationName));
    }
  }, [migrationName, snapshotNameEdited]);

  return { snapshotName, setSnapshotName, snapshotNameEdited, setSnapshotNameEdited } as const;
}

export default useSnapshotName;
